import { useAuth } from '../auth/AuthProvider'

export interface UserRole {
    isRiskManager: boolean
    userId: string
    loading: boolean
}

// Thin adapter over the auth context, preserving the original hook's shape so
// ported components need no changes.
export function useUserRole(): UserRole {
    const { user, ready } = useAuth()
    return {
        isRiskManager: Boolean(user?.isRiskManager),
        userId: user?.userId || '',
        loading: !ready,
    }
}
